import { Injectable } from '@angular/core'
import { map } from 'rxjs'
import { CommonRepository } from 'src/domain/repositories/common.repository'
import { DefaultResultData } from '../entities/base.entity'
import {
	DistrictTypeEntity,
	PostCodeTypeEntity,
	ProvinceTypeEntity,
	SubDistrictTypeEntity,
} from '../entities/common.entity'
import { DistrictMapper } from '../mappers/common/district.mapper'
import { PostCodeMapper } from '../mappers/common/post-code.mapper'
import { ProvinceMapper } from '../mappers/common/province.mapper'
import { SubDistrictMapper } from '../mappers/common/sub-district.mapper'

@Injectable({
	providedIn: 'root',
})
export class CommonImplementationRepository extends CommonRepository {
	provinceMapper = new ProvinceMapper()
	districtMapper = new DistrictMapper()
	subDistrictMapper = new SubDistrictMapper()
	postCodeMapper = new PostCodeMapper()

	GetProvince() {
		return this.get<DefaultResultData<ProvinceTypeEntity[]>>(`api/Addresses/Provinces`).pipe(
			map((response) => {
				return response.data.map((item) => {
					return this.provinceMapper.mapFrom(item)
				})
			}),
		)
	}

	GetDistrict(params: { provinceCode: string }) {
		return this.get<DefaultResultData<DistrictTypeEntity[]>>(
			`api/Addresses/Province/${params.provinceCode}/Districts`,
		).pipe(
			map((response) => {
				return response.data.map((item) => {
					return this.districtMapper.mapFrom(item)
				})
			}),
		)
	}

	GetSubDistrict(params: { districtCode: string }) {
		return this.get<DefaultResultData<SubDistrictTypeEntity[]>>(
			`api/Addresses/District/${params.districtCode}/SubDistricts`,
		).pipe(
			map((response) => {
				return response.data.map((item) => {
					return this.subDistrictMapper.mapFrom(item)
				})
			}),
		)
	}

	GetZipCode(params: { subDistrictCode: string }) {
		return this.get<DefaultResultData<PostCodeTypeEntity[]>>(
			`api/Addresses/SubDistrict/${params.subDistrictCode}/Posts`,
		).pipe(
			map((response) => {
				return response.data.map((item) => {
					return this.postCodeMapper.mapFrom(item)
				})
			}),
		)
	}
}
